<template>
  <div
    style="
      overflow: hidden;
      display: flex;
      flex-direction: column;
      height: 100%;
    "
  >
    <ul
      style="
        border-bottom: 1px solid #e2e2e2;
        padding: 15px;
        display: flex;
        align-items: center;
      "
    >
      <li style="flex: 1">
        权限配置
        <el-checkbox label="全选" value="all" @change="onTotalChange($event)" />
      </li>
      <el-button type="primary" @click="onSubmit()">提交</el-button>
    </ul>
    <ul
      style="
        font-size: 14px;
        display: flex;
        flex-direction: column;
        flex: 1;
        overflow: hidden;
        position: relative;
        padding: 0 10px;
        margin: 10px 0;
      "
      class="role_authorize_box"
    >
      <el-checkbox-group
        v-model="state.sjqx"
        style="display: flex; flex-direction: column; flex: 1; overflow: hidden"
        :key="state.key"
      >
        <el-table
          :data="state.menus"
          row-key="id"
          default-expand-all
          :tree-props="{ children: 'menus' }"
          v-loading="!Array.isArray(state.menus)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
          :default-sort="{
            prop: state.params.sort_field,
            order:
              state.params.sort_value == 'desc' ? 'descending' : 'ascending',
          }"
          @sort-change="onSortChange"
        >
          <el-table-column prop="name" sortable="name" label="菜单名称">
            <template #default="{ row }">
              <el-checkbox
                :label="row.name"
                :value="row.id.toString()"
                :title="row.id"
                style="font-weight: 600"
                @change="onMenuChange($event, row)"
              />
            </template>
          </el-table-column>
          <el-table-column label="操作权限" :width="600">
            <template #default="{ row }">
              <div class="flex flex-wrap">
                <el-checkbox
                  label="全选"
                  :value="'all-' + row.id"
                  v-if="row.btnIds?.length > 1"
                  style="font-weight: 600; color: #ffa500"
                  @change="onAllChange($event, row)"
                />
                <el-checkbox
                  v-for="item in row.btns"
                  :key="item"
                  :label="item.name"
                  :title="item.id"
                  :value="item.id.toString()"
                  @change="onBtnChange($event, item, row)"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="数据权限">
            <template #default="{ row }">
              <template v-if="row.is_data_auth">
                <el-checkbox
                  label="全部"
                  :value="'sjqx-' + row.id + '-1'"
                  @change="onDataAuthChange($event, 'sjqx-' + row.id + '-', 1)"
                />
                <el-checkbox
                  label="部门及下级"
                  :value="'sjqx-' + row.id + '-2'"
                  @change="onDataAuthChange($event, 'sjqx-' + row.id + '-', 2)"
                />
                <el-checkbox
                  label="仅部门"
                  :value="'sjqx-' + row.id + '-3'"
                  @change="onDataAuthChange($event, 'sjqx-' + row.id + '-', 3)"
                />
                <el-checkbox
                  label="个人"
                  :value="'sjqx-' + row.id + '-4'"
                  @change="onDataAuthChange($event, 'sjqx-' + row.id + '-', 4)"
                />
              </template>
            </template>
          </el-table-column>
        </el-table>
      </el-checkbox-group>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { adminRole_detail, adminRole_auth } from "@/http/adminRole";
import { menu_tree } from "@/http/menu";
import { ElMessage } from "element-plus";
export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const state = reactive({
      data: [],
      ids: [],
      params: {},
      sjqx: [],
    });
    let totalIds = [];
    onMounted(() => {
      if (props.id) {
        menu_tree().then((res) => {
          if (res.status == 200) {
            const { list } = res.data.data;
            state.menus = buildMenu(list);
          }
        });

        adminRole_detail(props.id).then((res) => {
          if (res.status == 200) {
            const { data } = res.data;
            state.model = data;

            let menus = [];
            if (data.menus) {
              menus = data.menus.split(",")?.map((m) => m.toString());
            }

            state.sjqx = [
              ...menus,
              ...data.data_auth?.map((m) => {
                return "sjqx-" + m.menu + "-" + m.type;
              }),
            ];
          }
        });
      }
    });

    //重构菜单数组
    const buildMenu = (data = []) => {
      let res = [];
      data.forEach((e) => {
        totalIds.push(e.id.toString());
        if (e.is_data_auth) totalIds.push("sjqx-" + e.id + "-1");
        e.menus = buildMenu(e.children?.filter((w) => w.type == 1));
        e.menuIds = e.menus.map((m) => m.id.toString());
        e.btns = buildMenu(e.children?.filter((w) => w.type == 0));
        e.btnIds = e.btns.map((m) => m.id.toString());
        if (e.children?.length > 0) totalIds.push("all-" + e.id);
        res.push(e);
      });

      return res;
    };

    //总权限
    const onTotalChange = (checked) => {
      if (checked) {
        state.sjqx = totalIds;
      } else {
        state.sjqx = [];
      }
    };

    const builChilren = (item) => {
      let res = [];
      if (item.btnIds?.length > 0) res.push("all-" + item.id);
      if (item.is_data_auth) res.push("sjqx-" + item.id + "-1");

      item.children?.forEach((e) => {
        res.push(e.id.toString());

        if (e.is_data_auth) {
          const child = state.sjqx.find((w) =>
            w.startsWith("sjqx-" + e.id + "-"),
          );
          if (!child) {
            res.push("sjqx-" + e.id + "-1");
          } else {
            res.push(child);
          }
        }

        if (e.btnIds?.length > 0) {
          res.push("all-" + e.id);
        }
        res = [...res, ...builChilren(e)];
      });
      return res;
    };

    //菜单选择事件
    const onMenuChange = (checked, menu) => {
      const ids = builChilren(menu);
      if (checked) {
        state.sjqx = [...new Set([...state.sjqx, ...ids])];
      } else {
        state.sjqx = state.sjqx.filter((w) => !ids.includes(w));
      }
    };

    //菜单下的全选事件
    const onAllChange = (checked, menu) => {
      if (checked) {
        state.sjqx = [...new Set([...state.sjqx, ...menu.btnIds])];
      } else {
        state.sjqx = state.sjqx.filter((w) => !menu.btnIds.includes(w));
      }
    };

    const onBtnChange = (checked, item) => {
      if (!checked)
        state.sjqx = state.sjqx.filter((w) => w != "all-" + item.fid);
    };

    const onSubmit = () => {
      let data = {
        id: props.id,
        menus: state.sjqx.join(","),
        data_auth: state.sjqx
          .filter((w) => w.toString().includes("sjqx"))
          .map((m) => {
            const arr = m.split("-");
            return { menu: parseInt(arr[1]), type: parseInt(arr[2]) };
          }),
      };

      adminRole_auth(data).then((res) => {
        if (res.status == 200) {
          ElMessage({
            message: res.data.msg,
            showClose: true,
            dangerouslyUseHTMLString: true,
            type: res.status ? "success" : "error",
          });
          if (res.status == 200) {
            setTimeout(() => {
              emit("close");
            }, 500);
          }
        }
      });
    };

    //数据权限改变事件
    const onDataAuthChange = (checked, prefix, type) => {
      state.sjqx = state.sjqx.filter((w) => !w.toString().includes(prefix));
      if (checked) state.sjqx.push(prefix + type);
    };

    return {
      state,
      onSubmit,
      onTotalChange,
      onAllChange,
      onMenuChange,
      onDataAuthChange,
      onBtnChange,
    };
  },
};
</script>
<style lang="scss">
.role_authorize_box {
  .el-checkbox-group {
    line-height: inherit;
    font-size: inherit;
  }
}
</style>
<style scoped lang="scss">
th,
td {
  padding: 10px;
}
</style>
